import React, { useState, useEffect } from 'react'
import Toggle from 'react-toggle'
import { CompareChart } from './compareChart'
import * as config from './config'

export const AllCountriesChart = () => {
  const [selected, setSelected] = useState<
    [CompCountryDataElement, CompCountryDataElement]
  >()
  const [showNew, setShowNew] = useState<boolean>(false)
  const [showDeath, setShowDeath] = useState<boolean>(false)
  const [showPop, setShowPop] = useState<boolean>(false)
  const [compData, setCompData] = useState<CompCountryDataElement[]>([])
  const allDataArrays = [
    'cumCases',
    'newCases',
    'cumDeath',
    'newDeath',
    'cumCasesPop',
    'newCasesPop',
    'cumDeathPop',
    'newDeathPop'
  ]
  useEffect(() => {
    fetch('https://interaktiv.tagesanzeiger.ch/2020/covid-19-ausbruch-im-vergleich/countryComp.json')
      .then(response => {
        return response.json()
      })
      .then((data: CompCountryDataElement[]) => {
        setCompData(
          data.filter(f => {
            let hasData = false
            allDataArrays.forEach(d => {
              if (f[d].length > 0) hasData = true
            })
            if (hasData) return f
          })
        )
        setSelected([
          data.find(f => f.code == 'CH') || data[0],
          data.find(f => f.code == 'SE') || data[1]
        ])
      })
  }, [])

  const valueType: valueTypeType = showNew ? 'cum' : 'new'
  const dataType: dataTypeType = showDeath ? 'death' : 'cases'
  const popType: popTypeType = showPop ? 'pop' : 'abs'
  const drawProp = config.drawProp[valueType][dataType][popType]

  let countrySelectOptions: CompCountryDataElement[] = compData
    .filter(f => {
      if (f[drawProp].length > 0) return f
    })
    .sort((a, b) => {
      return a.name.localeCompare(b.name, 'de')
    })
  const Options = () => (
    <div className='optionsWrapper'>
      <Switch
        isOn={showNew}
        toggle={setShowNew}
        labels={['Neue Fälle', 'Kumuliert']}
      />
      <Switch
        isOn={showDeath}
        toggle={setShowDeath}
        labels={['Infektionen', 'Todesfälle']}
      />
      <Switch
        isOn={showPop}
        toggle={setShowPop}
        labels={['Absolut', 'pro 1 Mio. Einwohner']}
      />
    </div>
  )
  const handleManualSelection = (code: string) => {
    let country = compData.find(f => f.code == code)
    if (country && selected) setSelected([selected[0], country])
  }
  return (
    <>
      <div className='ui vertical very fitted segment'>
        {compData.length > 0 && selected && selected.length > 0 && (
          <>
            <div className='ui  container '>
              {!config.isMobile && <Options />}
            </div>
            <div className='ui container chart big'>
              <h3 style={{ marginLeft: config.isMobile ? '0' : '80px' }}>
                {config.bigChartTitle[valueType][dataType][popType].t}
              </h3>
              <div
                className='subtitle'
                style={{ marginLeft: config.isMobile ? '0' : '73px' }}
              >
                <img src={require('images/legende_arrow_up.jpg')} width={15} />{' '}
                {config.bigChartTitle[valueType][dataType][popType].s}
              </div>
              <CompareChart
                data={compData}
                valueType={valueType}
                dataType={dataType}
                popType={popType}
                selected={[selected[0].code, selected[1].code]}
                manualSelect={
                  config.isMobile ? undefined : handleManualSelection
                }
              />
              <div
                className='source'
                style={{ marginLeft: config.isMobile ? '0' : '80px' }}
              >
                <img
                  src={require('images/legende_arrow_right.jpg')}
                  width={12}
                />{' '}
                {config.bigChartTitle[valueType][dataType][popType].x}
              </div>
              {config.isMobile && <Options />}
            </div>
          </>
        )}
      </div>
    </>
  )
}

// Sort-Toggle
const Switch = ({
  isOn,
  toggle,
  labels
}: {
  isOn: boolean
  toggle: React.SetStateAction<any>
  labels: [string, string]
}) => {
  return (
    <div className='bigToggleWrapper'>
      <div className='center'>
        <div className={'label ' + (!isOn ? '' : 'off')}>{labels[0]}</div>
        <div className='toggleContainer'>
          <Toggle
            defaultChecked={isOn}
            icons={false}
            onChange={e => {
              toggle(e.target.checked)
            }}
          />
        </div>
        <div className={'label right ' + (isOn ? '' : 'off')}>{labels[1]}</div>
      </div>
    </div>
  )
}
